__turbopack_context__.v({
  "accordionRoot": "Ow-Oza_accordionRoot",
  "desktopTable": "Ow-Oza_desktopTable",
  "mobileAccordion": "Ow-Oza_mobileAccordion",
  "mobileListView": "Ow-Oza_mobileListView",
  "technicalSpec": "Ow-Oza_technicalSpec",
  "technicalSpecs": "Ow-Oza_technicalSpecs",
  "twoImageSection": "Ow-Oza_twoImageSection",
});
